import { useIsMobile } from '@/data/hooks/useIsMobile';
import { ModalOutfitsProvider } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { useOutfits } from '@/data/Content/Outfits';
import { useLockBodyScroll } from '@/utils/useLockBodyScroll';
import { useContext, useEffect } from 'react';
import { EventsContext } from '@/data/context/events';
import { OutfitStages } from '@/components/blocks/ModalOutfits/parts/OutfitStages/OutfitStages';

interface ModalOutfitsProps {
	id?: string;
	name?: string;
	image: string;
	part_numbers: string[];
	onClose: () => void;
}

export const ModalOutfits: React.FC<ModalOutfitsProps> = ({
	id,
	name,
	image,
	part_numbers,
	onClose,
}) => {
	const isMobile = useIsMobile();
	const outfits = useOutfits({ partNumbers: part_numbers, id, name });

	const { onViewLook } = useContext(EventsContext);

	useEffect(() => {
		if (outfits.products.length > 0 && !outfits.isLoadingAvailability) {
			onViewLook({
				gtm: {
					look_id: id || 'ModalOutfits',
					look_name: name || 'ModalOutfits',
					items: outfits.products,
					settings: outfits.settings,
					availability: outfits.availability,
				},
			});
		}
	}, [outfits.products, outfits.isLoadingAvailability]);

	const isLoadingData = outfits.isLoadingProducts || outfits.isLoadingAvailability;

	useLockBodyScroll(true);

	return (
		<ModalOutfitsProvider value={{ isMobile, onClose, ...outfits }}>
			<OutfitStages image={image} isLoadingData={isLoadingData} />
		</ModalOutfitsProvider>
	);
};
